/**
 * One place for how a run's context-binding verdict reads.
 *
 * The verdicts themselves are the backend projection's (app/schemas/context_binding.py,
 * app/services/context_binding.py): per-binding `bound` / `not_provided` / `missing` / `conflict`
 * and the aggregate `complete` / `partial` / `conflict` / `unknown`. The server decides; this
 * module only decides how each one is worded and coloured, so no surface can invent a fifth
 * status or dress an unrecognised one up as reassurance.
 */

export const BINDING_STATUS_META = {
  bound:        { label: "מאומת",    cls: "bg-green-100 text-green-700 border-green-200" },
  not_provided: { label: "לא סופק",  cls: "bg-gray-200 text-gray-600 border-gray-300" },
  missing:      { label: "חסר",      cls: "bg-amber-100 text-amber-700 border-amber-200" },
  conflict:     { label: "סתירה",    cls: "bg-red-100 text-red-700 border-red-200" },
};

// A status this build does not know must not read as a pass. "לא מאומת" claims nothing either way.
export const UNKNOWN_BINDING_STATUS_META = { label: "לא מאומת", cls: "bg-amber-100 text-amber-700 border-amber-200" };

export const bindingStatusMeta = (status) => BINDING_STATUS_META[status] || UNKNOWN_BINDING_STATUS_META;

export const BINDING_STATE_CLS = {  complete: "bg-green-100 text-green-700 border-green-200",
  partial:  "bg-amber-100 text-amber-700 border-amber-200",
  conflict: "bg-red-100 text-red-700 border-red-200",
  unknown:  "bg-gray-200 text-gray-600 border-gray-300",
};

export const UNKNOWN_STATE_CLS = "bg-gray-200 text-gray-600 border-gray-300";
export const UNKNOWN_STATE_LABEL = "מצב השיוך לא זוהה — יש לבדוק ידנית";

/**
 * The aggregate badge: the server's own `state_label`, coloured by its `state`. Label and colour
 * are returned together so a missing label can never end up on a reassuring colour — both fall
 * back to the neutral pair, which makes no claim in either direction.
 */
export function bindingStateMeta(binding) {
  const label = typeof binding?.state_label === "string" ? binding.state_label.trim() : "";
  if (!label) return { label: UNKNOWN_STATE_LABEL, cls: UNKNOWN_STATE_CLS };
  return { label, cls: BINDING_STATE_CLS[binding?.binding_state] || UNKNOWN_STATE_CLS };
}
